import {
  Wrench,
  Building2,
  PaintBucket,
  Zap,
  Hammer,
  TreePine,
  Droplets,
  Wind,
  Layers,
  Home,
  Square,
  Grid3x3,
} from 'lucide-react';

const trades = [
  { icon: Wrench, label: 'General Contractors' },
  { icon: Building2, label: 'Commercial Builders' },
  { icon: PaintBucket, label: 'Remodelers' },
  { icon: Zap, label: 'Electrical' },
  { icon: Hammer, label: 'Framing & Carpentry' },
  { icon: TreePine, label: 'Landscaping' },
  { icon: Droplets, label: 'Plumbing' },
  { icon: Wind, label: 'HVAC' },
  { icon: Layers, label: 'Concrete' },
  { icon: Home, label: 'Roofing' },
  { icon: Square, label: 'Flooring' },
  { icon: Grid3x3, label: 'Tile & Stone' },
];

const stats = [
  { value: '10x', label: 'faster estimates' },
  { value: '0', label: 'missed lien waivers' },
  { value: '100%', label: 'paper trail coverage' },
  { value: '24/7', label: 'field access' },
];

const industryLogos = ['NAHB', 'AGC', 'NRCA', 'NECA', 'PHCC'];

export function BuiltForSection() {
  return (
    <section className="relative py-28 sm:py-32 overflow-hidden">
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, #1a1a1a 0%, #111111 40%, #1a1a1a 100%)',
        }}
      />

      {/* Safety-stripe accent bar */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1.5 safety-stripe opacity-60" aria-hidden="true" />

      <div className="relative mx-auto max-w-6xl px-6">
        <div className="mb-16 text-center reveal">
          <span className="mb-4 inline-block rounded-full border border-build-700/40 bg-build-900/40 px-3 py-1 text-xs font-medium text-orange-400">
            Built for Builders
          </span>
          <h2 className="mb-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Designed for Every Trade
          </h2>
          <p className="mx-auto max-w-2xl text-zinc-400">
            Whether you are a one-person remodeler or a 50-crew commercial contractor — GCs, subs, and field crews all
            work from the same source of truth.
          </p>
        </div>

        {/* Trade cards — 12 trades, 2 cols mobile / 3 cols tablet / 4 cols desktop */}
        <div className="mb-14 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {trades.map((trade) => (
            <div
              key={trade.label}
              className="reveal flex flex-col items-center rounded-xl border border-build-700/20 bg-build-900/30 p-5 text-center transition hover:border-orange-500/30 hover:bg-build-900/50"
            >
              <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-orange-500/10">
                <trade.icon className="h-5 w-5 text-orange-400" />
              </div>
              <span className="text-xs font-medium text-zinc-300">{trade.label}</span>
            </div>
          ))}
        </div>

        {/* Industry trust strip */}
        <div className="reveal mb-16 rounded-xl border border-build-700/20 bg-build-900/20 px-6 py-5">
          <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between">
            <span className="text-[10px] font-semibold uppercase tracking-[0.22em] text-zinc-500">
              As trusted by builders in
            </span>
            <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2">
              {industryLogos.map((logo) => (
                <span
                  key={logo}
                  className="text-sm font-bold uppercase tracking-wider text-zinc-500 transition hover:text-zinc-300"
                >
                  {logo}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-6 lg:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.label} className="reveal text-center">
              <div className="mb-1 text-3xl font-extrabold text-orange-400 sm:text-4xl">{stat.value}</div>
              <div className="text-sm text-zinc-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
